/**
 * Parametrii de demo lipicioși pe durata TABULUI: `?voice=` (fost `?aig_voice=`;
 * `?aig_skin=` a dispărut pe 19 aug 2026 - HUD e singura piele).
 *
 * Trăiau în `sdk.ts`; au ieșit într-un modul propriu pe 12 aug 2026 fiindcă au
 * acum DOUĂ porți de intrare - linkul (`?voice=2`) și comanda scrisă în
 * card (`/voice-2`, vezi `orbchat/index.ts`) - iar cele două trebuie să scrie
 * și să citească exact același loc. O a doua copie a cheii ar însemna două
 * mecanisme care se contrazic la prima navigare.
 *
 * De ce lipicios: o conversație vocală navighează prin magazin (`open_search`,
 * `navigate`), fiecare navigare descarcă documentul și pierde query-ul - deci
 * vocea (sau pielea) s-ar schimba în mijlocul propoziției. `sessionStorage`
 * moare odată cu tabul, deci nimic nu rămâne agățat de situl clientului.
 */

/**
 * Citește un parametru cu VALOARE: URL-ul bate storage-ul, iar valoarea trece
 * obligatoriu prin `isValid` - un string arbitrar din URL n-are voie să ajungă
 * mai departe, iar un storage scris de altcineva (sau rămas de la o versiune
 * mai veche a setului) se ignoră.
 */
export function stickyUrlValue(name: string, isValid: (value: string) => boolean): string | null {
  try {
    const fromUrl = new URLSearchParams(location.search).get(name);
    if (fromUrl !== null && isValid(fromUrl)) {
      sessionStorage.setItem(name, fromUrl);
      return fromUrl;
    }
    const stored = sessionStorage.getItem(name);
    return stored !== null && isValid(stored) ? stored : null;
  } catch {
    return null;
  }
}

/**
 * Scrie valoarea fără să treacă prin URL - calea comenzilor scrise. Validarea
 * rămâne a apelantului (el știe setul), exact ca la citire; un storage
 * inaccesibil (sandbox, cookies blocate) nu are voie să arunce.
 */
export function setStickyValue(name: string, value: string): void {
  try {
    sessionStorage.setItem(name, value);
  } catch {
    /* fără storage, alegerea ține doar cât pagina - acceptat */
  }
}
